import { createSelector } from 'reselect'
import selectItemsById from './selectItemsById'

const selectItems = createSelector(selectItemsById, itemsById =>
  Object.values(itemsById)
)
export default selectItems
